import { withEventContext } from "@codat/analytics";
import { useConfig } from "contexts/ConfigContext";
import { RouteComponentProps } from "react-router-dom";

import { ClientParams } from "config/urls";

import ClientLandingContainer from "./ClientLandingContainer";

function ClientContainerContent({ match }: RouteComponentProps<ClientParams>) {
  const { state } = useConfig();
  return (
    <ClientLandingContainer
      clientId={match.params.clientId}
      data={state.data}
    />
  );
}

const ClientContainer = withEventContext<
  RouteComponentProps<ClientParams> & JSX.IntrinsicAttributes
>(ClientContainerContent, "Client landing page");

export default ClientContainer;
